import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { t } from '../../../services/i18nService';

import OptionButton from './OptionButton';

const DeliveryButton = ({ clickHandler, icon, a11yAttributes }) => {
    return (<OptionButton
        iconClass={`fa fa-fw ${icon}`}
        clickHandler={clickHandler}
        title={t('options.fileDelivery')}
        noChildren
        a11yAttributes={a11yAttributes}
    />);
};

DeliveryButton.propTypes = {
    clickHandler: PropTypes.func.isRequired,
    icon: PropTypes.string,
    a11yAttributes: PropTypes.object,
};

function mapStateToProps(state) {
    return { icon: state.ui.variables.options__fileDeliveryIcon };
}

const FileDeliveryButton = connect(mapStateToProps)(DeliveryButton);

export default FileDeliveryButton;
